module.exports = __webpack_public_path__ + "static/img/Push pull 3.0m.6c180a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Push pull 3.0m.jpg
// module id = 98
// module chunks = 1